import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15

export default {
    services: {
        createBranch: (branch, token) => {
            return axios(token).post(`/branches`, branch);
        },
        getBranches: (limit, page, query, token) => {
            return axios(token).get(`/branches?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
        },
        getBranchById: (branchId, token) => {
            return axios(token).get(`/branches/${branchId}`);
        },
        updateBranchById: (branchId, body, token) => {
            return axios(token).put(`/branches/${branchId}`, body);
        },
        deleteBranchById: (branchId, token) => {
            return axios(token).delete(`/branches/${branchId}`);
        },
        getBranchesByOperatorId: (operatorId, pagination, token) => {
            if (Object.entries(pagination).length === 0) {
                return axios(token).get(`/operators/${operatorId}/branches`);
            } else {
                return (pagination.type === "change") ? axios(token).get(`/operators/${operatorId}/branches?limit=${limit}&page=${pagination.page}`) : axios(token).get(`${pagination.url}`);
            }
        },
        getBranchesOptionsByOperatorId: (operatorId, token) => {
            return axios(token).get(`/operators/${operatorId}/branches-options`);
        },
        deleteManyBranchesById: (body, token) => {
            return axios(token).post(`/bulk-delete-branches`, body)
        },
        getBranchesOptions: (token) => {
            return axios(token).get(`/branches-options`);
        },
        getBranchesOptionsToFilters: (operatorId, token) => {
            return axios(token).get(`/destinations-filters${operatorId? `?operatorId=${operatorId}` : ""}`);
        },
    }
}